var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "field",
    _vm._b(
      {
        scopedSlots: _vm._u(
          [
            {
              key: "field-description",
              fn: function () {
                return [_vm._t("field-description")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "field",
      { ..._vm.$attrs, ..._vm.$props },
      false
    ),
    [
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["gfu-field-media", _vm.mediaFieldClass],
          attrs: { "data-qa": "image-field" },
        },
        [
          _c("input", {
            ref: "fileInput",
            staticClass: "gfu-field-media__input",
            attrs: {
              type: "file",
              accept: _vm.acceptedFormats,
              "data-qa": "image-field-input",
            },
            on: { change: _vm.onFileInputChange },
          }),
          _vm._v(" "),
          _vm.thumbUrl
            ? _c(
                "div",
                { staticClass: "gfu-field-media__img-wrapper" },
                [
                  _c(
                    "drop-area",
                    {
                      attrs: {
                        enabled: _vm.allowDrop && !_vm.readOnly,
                        name: _vm.name,
                        tabindex: "0",
                      },
                      on: { drop: _vm.uploadMedia },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "gfu-field-media__actions" },
                        [
                          _c(
                            "dropdown-group",
                            {
                              ref: "dropdown",
                              attrs: {
                                fixed: false,
                                "collapse-on-scroll": true,
                              },
                            },
                            [
                              (_vm.uploadApiAction || _vm.uploadApiFunction) &&
                              !_vm.readOnly
                                ? _c("dropdown-link", {
                                    attrs: {
                                      icon: "sync",
                                      label: "Replace",
                                      "data-qa": "image-field-button:Replace",
                                    },
                                    on: { click: _vm.selectFileForUpload },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.allowDelete && !_vm.readOnly
                                ? _c("dropdown-link", {
                                    attrs: {
                                      icon: "trash-alt",
                                      label: "Delete",
                                      "data-qa": "image-field-button:Delete",
                                    },
                                    on: { click: _vm.deleteMedia },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isVideoType
                        ? _c("img", {
                            class: ["gfu-field-media__image", _vm.mediaClass],
                            attrs: {
                              src: _vm.cacheLessThumbUrl,
                              draggable: "false",
                              alt: _vm.displayName,
                              "data-qa": "image-field-image",
                            },
                          })
                        : _c("video", {
                            class: ["gfu-field-media__image", _vm.mediaClass],
                            attrs: {
                              src: _vm.cacheLessThumbUrl,
                              draggable: "false",
                              alt: _vm.displayName,
                              controls: "",
                              preload: "metadata",
                              controlslist:
                                "nodownload nofullscreen noremoteplayback",
                              "disable-picture-in-picture": "",
                              muted: "",
                              "data-qa": "image-field-video",
                            },
                            domProps: { muted: true },
                          }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (_vm.uploadApiAction || _vm.uploadApiFunction) && !_vm.thumbUrl
            ? [
                _vm.allowDrop
                  ? _c(
                      "drop-area",
                      {
                        staticClass: "_flex _flexcol _jc-c _ai-c",
                        attrs: {
                          enabled: _vm.allowDrop && !_vm.readOnly,
                          preview: false,
                          name: _vm.name,
                          tabindex: "0",
                        },
                        on: {
                          drop: _vm.uploadMedia,
                          click: _vm.selectFileForUpload,
                        },
                      },
                      [
                        !_vm.readOnly
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "gfu-btn gfu-btn--circle gfu-btn--circle-big gfu-btn--primary",
                                  attrs: { href: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.selectFileForUpload.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("base-icon", {
                                    attrs: { name: "upload" },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "gfu-field-media__input-title" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.title) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "gfu-field-media__input-description",
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.description) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "gfu-btn gfu-btn--circle gfu-btn--circle-big gfu-btn--gray",
                                  attrs: { href: "#", disabled: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.selectFileForUpload.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_c("base-icon", { attrs: { name: "ban" } })],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "gfu-field-media__input-title gfu-field-media__input-title--disabled",
                                },
                                [_vm._v("This field is disabled.")]
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("progress-overlay", { attrs: { visible: _vm.isProcessing } }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }